import React from "react"

const Projects = ({ className = "", ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      className={className}
      {...props}
    >
      <path
        d="M25.3333 3.2002H6.66667C5.19391 3.2002 4 4.3941 4 5.86686V24.5335C4 26.0063 5.19391 27.2002 6.66667 27.2002H25.3333C26.8061 27.2002 28 26.0063 28 24.5335V5.86686C28 4.3941 26.8061 3.2002 25.3333 3.2002Z"
        stroke="#463DFB"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.6665 8.53271V17.866"
        stroke="#463DFB"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 8.53271V13.866"
        stroke="#463DFB"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.3335 8.53271V20.5327"
        stroke="#463DFB"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default Projects
